const dialogTitle = {
  styleOverrides: {
    root: ({ theme }: { theme: any }) => ({
      ...theme.typography.h6,
      fontWeight: 600,
      color: theme.palette.text.primary,
      padding: theme.spacing(2, 2.5),
      borderBottom: `${theme.borders.borderWidth[1]} solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
    }),
  },
};

export default dialogTitle;
